export function genQueryToStr(query = {}) {
  return Object.keys(query).map((key) => {
    const value = query[key];
    return `${key}=${value}`;
  })
    .join('&');
}

export function getQueryObj() {
  let query = {};
  // #ifdef H5
  query = app?.$route?.query || {};
  // #endif
  // #ifdef MP-WEIXIN || MP-QQ
  const currentPage = getCurrentPages()[getCurrentPages().length - 1];
  query = currentPage?.options || {};
  // #endif
  return query;
}

export function getQueryStr() {
  return genQueryToStr(getQueryObj());
}
